import { Component, Inject, OnInit, PLATFORM_ID } from '@angular/core';
import { CommonModule, isPlatformBrowser } from '@angular/common';
import { RouterLink } from '@angular/router';
import { FOOTER_COLUMNS, FOOTER_LEGAL, FOOTER_PARTNER_BOX, FOOTER_SOCIAL, FOOTER_TAGLINE } from '../../features/homepage/homepage.content';

// Site footer. New to the site with the 2026 homepage; used on the homepage
// first and can be added to the horizontal layout once the other pages are
// checked against it. Copy and links live in homepage.content.ts.
@Component({
  selector: 'app-site-footer',
  standalone: true,
  imports: [CommonModule, RouterLink],
  templateUrl: './site-footer.component.html',
})
export class SiteFooterComponent implements OnInit {
  readonly columns = FOOTER_COLUMNS;
  readonly social = FOOTER_SOCIAL;
  readonly tagline = FOOTER_TAGLINE;
  readonly partnerBox = FOOTER_PARTNER_BOX;
  readonly legal = FOOTER_LEGAL;
  readonly year = new Date().getFullYear();

  // Light/dark toggle (moved here from the header). Same contract the
  // navbar bootstraps on load: html.tw-dark + localStorage.theme = 'tw-dark' | 'light'.
  isDark = false;
  private isBrowser: boolean;

  constructor(@Inject(PLATFORM_ID) platformId: object) {
    this.isBrowser = isPlatformBrowser(platformId);
  }

  ngOnInit(): void {
    if (!this.isBrowser) return;
    this.isDark = document.documentElement.classList.contains('tw-dark') || localStorage.getItem('theme') === 'tw-dark';
  }

  setTheme(dark: boolean): void {
    if (!this.isBrowser) return;
    const html = document.documentElement;
    html.classList.toggle('tw-dark', dark);
    localStorage.setItem('theme', dark ? 'tw-dark' : 'light');
    this.isDark = dark;
  }
}
